/**
 * @param callbackOptions Object An object with callbacks: progress and done
 * @param duration Integer Total duration in milliseconds
 * @returns Object An object with operation functions: start and cancel
 */
export function animate(
  callbackOptions: {
    progress?: (percentage: number) => void;
    done?: () => void;
  },
  duration = 1000,
) {
  let startTime = 0;
  let isCanceled = false;

  const animation = function (timestamp: number) {
    if (isCanceled) {
      return;
    }

    startTime = startTime || timestamp;

    const animationTime = timestamp - startTime;
    const percentage = animationTime / duration;

    if (percentage < 1) {
      callbackOptions.progress?.(percentage);
      requestAnimationFrame(animation);
    } else {
      callbackOptions.progress?.(1);
      callbackOptions.done?.();
    }
  };

  const start = () => {
    requestAnimationFrame(animation);
  };

  const cancel = () => {
    isCanceled = true;
  };

  return { start, cancel };
}
